export const REACTION_TYPE_BIGUP = 'bigUp'
export const REACTION_TYPE_STUPES = 'stupes'